import { IClinicListResponseData } from "@/api_framework/api_modals/Clinics";
import { IOrgCityListResponseData, IOrgProviderListResponseData } from "@/api_framework/api_modals/Org";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ICommandPalleteState, ISidebarState, IUIStates, UIThemeNamesType } from "../reducer_interface";

const initialState: IUIStates = {
  commandPallete: { query: "", show: false },
  apiErrorCurl: null,
  theme: "VETIC",
  mappedCityId: null,
  clinics: [],
  cities: [],
  providers: [],
  mappedClinicId: null,
  mappedClinicName: null,
  sidebar: {
    mobile: { show: false },
    desktop: { show: false },
  },
};

const uiStatesSlice = createSlice({
  name: "ui_states_slice",
  initialState: initialState,
  reducers: {
    setUIOrgCities: (
      state,
      action: PayloadAction<{
        data: IOrgCityListResponseData[];
      }>,
    ) => {
      state.cities = action.payload.data;
    },
    setUIOrgProviders: (
      state,
      action: PayloadAction<{
        data: IOrgProviderListResponseData[];
      }>,
    ) => {
      state.providers = action.payload.data;
    },
    setUIOrgClinics: (
      state,
      action: PayloadAction<{
        data: IClinicListResponseData[];
      }>,
    ) => {
      state.clinics = action.payload.data;
    },
    setMappedClinicData: (
      state,
      action: PayloadAction<{
        name: string;
        id: string;
      }>,
    ) => {
      state.mappedClinicId = action.payload.id;
      state.mappedClinicName = action.payload.name;
    },
    setUITheme: (state, action: PayloadAction<UIThemeNamesType>) => {
      state.theme = action.payload;
    },
    setMappedCityId: (state, action: PayloadAction<string>) => {
      state.mappedCityId = action.payload;
    },
    setStaticSideBarStatus: (state, action: PayloadAction<{ status: boolean }>) => {
      state.sidebar.desktop.show = action.payload.status;
    },
    setStaticSideBarStatusMobile: (state, action: PayloadAction<{ status: boolean }>) => {
      state.sidebar.mobile.show = action.payload.status;
    },
    setShowCommandPallete: (state, action: PayloadAction<boolean>) => {
      state.commandPallete.show = action.payload;
    },
    setCommandPalleteState: (state, action: PayloadAction<ICommandPalleteState>) => {
      state.commandPallete = action.payload;
    },
    setSidebarState: (state, action: PayloadAction<ISidebarState>) => {
      state.sidebar = action.payload;
    },
    setAPIErrorCURL: (state, action: PayloadAction<string>) => {
      state.apiErrorCurl = action.payload;
    },
  },
});

export const {
  setCommandPalleteState,
  setStaticSideBarStatusMobile,
  setShowCommandPallete,
  setSidebarState,
  setStaticSideBarStatus,
  setMappedCityId,
  setMappedClinicData,
  setUIOrgCities,
  setUIOrgClinics,
  setUIOrgProviders,
  setAPIErrorCURL,
  setUITheme,
} = uiStatesSlice.actions;

export default uiStatesSlice.reducer;
